var _path, _rect, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 94,
    viewBox: "0 0 123 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99975 93.9437H112.648C118.171 93.9437 122.648 89.4665 122.648 83.9437V16.7485C122.648 11.2257 118.171 6.74851 112.648 6.74851H62.1456C59.7584 6.74851 57.5578 5.45779 56.3927 3.37425C55.2276 1.29072 53.027 0 50.6398 0H9.99976C4.47691 0 -0.000244141 4.47716 -0.000244141 10V83.9437C-0.000244141 89.4665 4.47691 93.9437 9.99975 93.9437Z",
    fill: "#214C7B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.21875,
    y: 10.1482,
    width: 109.601,
    height: 79.1562,
    rx: 10,
    fill: "black",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.649 93.9436H10C4.47715 93.9436 0 89.4665 0 83.9436V35.0646C0 29.5418 4.47716 25.0646 10 25.0646H59.9229C62.7601 25.0646 65.33 23.3908 66.477 20.7959C67.6241 18.201 70.194 16.5271 73.0311 16.5271H112.649C118.172 16.5271 122.649 21.0043 122.649 26.5271V83.9436C122.649 89.4665 118.172 93.9436 112.649 93.9436Z",
    fill: "#2D6CB2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8909_59087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 42H44L52 50V78C52 79.1 51.1 80 50 80H22C20.9 80 20 79.1 20 78V44C20 42.9 20.9 42 22 42Z",
    fill: "none",
    stroke: "#F2E2C4",
    strokeWidth: 2.2,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 42V50H52",
    fill: "none",
    stroke: "#F2E2C4",
    strokeWidth: 2.2,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 47.5H38",
    fill: "none",
    stroke: "#F2E2C4",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 55H47",
    fill: "none",
    stroke: "#F2E2C4",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 63.5V74.5H47",
    fill: "none",
    stroke: "#F2E2C4",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 71.5L34 66.5L40 69.5L45 63.5",
    fill: "none",
    stroke: "#F2E2C4",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8909_59087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 44,
    fill: "white",
    transform: "translate(11 38)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportEmpty);
export default __webpack_public_path__ + "static/media/reportEmpty.5753d399f3f8a47d17ad861f64deeeb2.svg";
export { ForwardRef as ReactComponent };